import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ErrorFallbackProps {
    error: Error;
    resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('errors');

    return (
        <div className="min-h-screen flex items-center justify-center bg-brand-cream p-6">
            <div className="bg-white p-10 rounded-[2.5rem] card-shadow max-w-lg w-full text-center border border-brand-clay/5">
                <div className="w-20 h-20 bg-rose-100 text-rose-500 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                    </svg>
                </div>

                <h1 className="text-3xl font-black text-brand-clay mb-3">{t('errors.somethingWentWrong')}</h1>
                <p className="text-brand-clay/60 font-medium mb-8">
                    {t('errors.temporaryErrorMessage')}
                </p>

                <div className="bg-brand-cream/50 p-4 rounded-xl mb-8 overflow-auto max-h-32 text-left">
                    <code className="text-xs text-rose-500 font-mono block break-words">
                        {error.message}
                    </code>
                </div>

                <div className="flex gap-4">
                    <button
                        onClick={resetErrorBoundary}
                        className="flex-1 py-4 bg-brand-terracotta text-white rounded-2xl font-black uppercase tracking-widest shadow-xl hover:scale-[0.98] transition-transform"
                    >
                        {t('errors.tryAgain')}
                    </button>
                    <button
                        onClick={() => {
                            resetErrorBoundary();
                            navigate('/');
                        }}
                        className="flex-1 py-4 bg-brand-clay text-white rounded-2xl font-black uppercase tracking-widest shadow-xl hover:scale-[0.98] transition-transform"
                    >
                        {t('errors.homePage')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
